export default class ProductSelectorOption {
    // #region Vars | private
    _currentValue;
    _selector = undefined;
    // #endregion
    // #region Vars
    name = "";
    member = "";
    caption = "";
    infoLink = "";
    infoText = "";
    controlType = "";
    controlAttributes = null;
    index = 0;
    allowMultible = false;
    isSelection = false;
    isFilterable = false;
    initialValue = null;
    values = [];
    currentValues = [];
    configuration = null;
    configurationValues = {};
    // #endregion
    // #region Properties
    get activeValues() {
        return this.values.filter(e => e.possible);
    }
    get currentValue() {
        return this._currentValue;
    }
    set currentValue(value) {
        // #region Check
        if (this.currentValue === value) {
            return;
        }
        // #endregion
        // #region Old
        var told = this._currentValue;
        this._currentValue = value;
        // #endregion
        // #region Value
        //Find Customization-Values
        let tValue = this.values.find(e => e.name === value);
        if (this._selector) {
            this._selector.OnValueChange(this, "currentValue", told, value);
        }
        // #endregion
        // #region Custom
        if (this._selector && tValue?.configuration) {
            this.configuration = tValue?.configuration;
            this.configurationValues = this._selector.getConfigurationValue(this.name);
        }
        else {
            this.configuration = undefined;
            this.configurationValues = undefined;
        }
        // #endregion
    }
    // #endregion
    // #region Constructor
    constructor(selector, init) {
        //Erst zuweisen, dann callback
        Object.assign(this, init);
        //Callback
        this._selector = selector;
    }
}
